import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { TRACKER_EYEBROW_SX, TRACKER_SECTION_TILE_SX } from './guestTableStyles';

/** Sections wrap into columns instead of stacking into one long scroll. */
export const TILE_FLEX = '1 1 320px';

/**
 * One section of a guest record: an inset well with an uppercase label. Tiles,
 * not rules — a host scans "where's the hotel?" faster across four small
 * surfaces than down four hairlines.
 *
 * Lifted out of GuestRecordEditor so the tag and link tiles can be their own
 * files without the editor importing them and them importing it back.
 */
export default function RecordSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <Box component="section" aria-label={title} sx={{ ...TRACKER_SECTION_TILE_SX, flex: TILE_FLEX }}>
      <Typography component="h3" sx={{ ...TRACKER_EYEBROW_SX, color: 'var(--tsb-brand-ink)' }}>
        {title}
      </Typography>
      {description ? (
        <Typography
          sx={{ mt: 0.75, color: 'var(--tsb-fg-muted)', fontSize: 11.5, lineHeight: 1.5 }}
        >
          {description}
        </Typography>
      ) : null}
      <Box sx={{ mt: 1.5 }}>{children}</Box>
    </Box>
  );
}
